import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import SchedulePage from "./pages/SchedulePage";
import UsersPage from "./pages/UsersPage";
import PublishedSchedulesPage from "./pages/PublishedSchedulesPage"; // 👈 NEW
import theme from "./theme/theme";
import AuthWrapper from "./auth/AuthWrapper";
import { UserProvider } from "./context/UserContext";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthWrapper>
        <UserProvider>
          <Router>
            <MainLayout>
              <Routes>
                <Route path="/" element={<SchedulePage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route
                  path="/published"
                  element={<PublishedSchedulesPage />} // 👈 NEW route
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </MainLayout>
          </Router>
        </UserProvider>
      </AuthWrapper>
    </ThemeProvider>
  );
}

export default App;
